import React, { useContext, useMemo } from "react";
import ReferenceField from "components/attributes/compare-table/reference-field";
import { AttributeTitle } from "./attribute-title";
import { TaskContext } from "contexts/task";
import { useAttributes } from "shared/hooks/use-attributes";
import { AttributePairValidationProvider } from "../contexts/attribute-validation-provider";
import { FieldWrapper } from "./field-wrapper";
import { AttributeFeedback } from "../attribute-feedback";
import { isAttributeFeedbackSupported } from "../attribute-feedback/lib/helpers";

import "./compare-table.scss";
import { useColumnTemplate } from "../../../shared/hooks/use-column-template";

// TODO: Unify this and remove attribute row when INT-4818 will be finished
export const AttributePairRow = ({
    attributesPair,
    removeAttribute,
    readOnlyOverride,
    references,
    // width,
    columnWidths,
    isReadOnlyAdd,
    isReadOnlyEdit,
    isReadOnlyDelete,
    isCompleted,
    isBrandVerified,
}) => {
    const [firstAttribute] = attributesPair;
    const { task } = useContext(TaskContext);
    const { data: attributesData } = useAttributes();
    const gridTemplate = useColumnTemplate(references.length + 2, columnWidths, references.length === 0);

    const mergedTooltip = useMemo(() => {
        return attributesPair
            .map(({ tooltip }) => tooltip)
            .filter((tooltip) => tooltip)
            .join(", ");
    }, [attributesPair]);

    return (
        <div
            id={firstAttribute.key}
            className="product-compare-row"
            style={gridTemplate}
        >
            <AttributeTitle
                tooltip={mergedTooltip}
                title={firstAttribute.name}
                attr={firstAttribute}
                removeAttribute={removeAttribute}
                codingWipKey={task.context.codingWipKey}
                isCompleted={task.isCompleted || isCompleted}
                isReadOnlyAdd={isReadOnlyAdd}
                isReadOnlyDelete={isReadOnlyDelete}
                isBrandVerified={isBrandVerified}
            />
            <AttributePairValidationProvider>
                <div
                    className="product-compare-row -inner"
                    style={{ gridTemplateColumns: `repeat(${attributesPair.length}, 1fr)` }}
                >
                    {attributesPair.map((attribute) => {
                        const showFeedback = isAttributeFeedbackSupported(attribute, task.taskType) && attributesData.hasOwnProperty(attribute.uuid);

                        return (
                            <div
                                key={`AIF_${attribute.uuid}`}
                                className={showFeedback ? "attribute-feedback-cell" : undefined}
                            >
                                <div className={showFeedback ? "attribute-feedback-field" : undefined}>
                                    <FieldWrapper
                                        attribute={attribute}
                                        isReadOnly={attribute.readOnly && !readOnlyOverride}
                                        readOnlyOverride={readOnlyOverride}
                                        task={task}
                                        isReadOnlyEdit={isReadOnlyEdit}
                                        isCompleted={isCompleted}
                                    />
                                </div>
                                {showFeedback && (
                                    <AttributeFeedback
                                        attr={attribute}
                                        taskType={task.taskType}
                                        taskKey={task.key}
                                        canEdit={!isCompleted}
                                        tooltipPosition="left"
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            </AttributePairValidationProvider>
            {references.map((ref, i) => {
                return (
                    <div key={ref.upc}>
                        {attributesPair.map((attribute) => {
                            return (
                                <ReferenceField
                                    key={`ROF_${attribute.uuid}_ref${i}`}
                                    value={ref[attribute.uuid]}
                                    attribute={attribute}
                                    readOnlyOverride={readOnlyOverride}
                                    isCompleted={task.isCompleted}
                                    upc={ref.upc}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

AttributePairRow.defaultProps = {
    references: [],
};
